/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TaskLogEntry,
    TaskLogEntryFromJSON,
    TaskLogEntryFromJSONTyped,
    TaskLogEntryToJSON,
} from './';

/**
 * 
 * @export
 * @interface TaskLogV2
 */
export interface TaskLogV2 {
    /**
     * 
     * @type {Array<TaskLogEntry>}
     * @memberof TaskLogV2
     */
    entries: Array<TaskLogEntry>;
}

export function TaskLogV2FromJSON(json: any): TaskLogV2 {
    return TaskLogV2FromJSONTyped(json, false);
}

export function TaskLogV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskLogV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entries': ((json['entries'] as Array<any>).map(TaskLogEntryFromJSON)),
    };
}

export function TaskLogV2ToJSON(value?: TaskLogV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entries': ((value.entries as Array<any>).map(TaskLogEntryToJSON)),
    };
}


